<!--日清周结数据管理-->
<template>
    <div class="home-rqzj-container">
        <div class="home-rqzj-manager-container" v-show="showMode==='tree'">
            <!--目录-->
            <div class="home-l-container">
                <div class="home-l-top-container">
                    <div class="home-l-box cursor">
                        <svg style="margin-left: 5px" @click="backList" t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                    </div>
                    <div class="home-r-box">
                        目录
                    </div>
                    <div class="home-l-box cursor" title="刷新">
                        <svg t="1775018007241" class="icon" @click="resetSearch" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8064" width="30" height="30"><path d="M512 57.677643C261.084506 57.677643 57.677643 261.084506 57.677643 512s203.406863 454.322357 454.322357 454.322357 454.322357-203.406863 454.322357-454.322357S762.915494 57.677643 512 57.677643z" fill="#ff7f2e" p-id="8065" data-spm-anchor-id="a313x.search_index.0.i11.35603a81rpIomP" class="selected"></path><path d="M581.060548 231.577511c-41.567834-41.568721-84.297206-66.239667-95.428104-55.108769-11.137997 11.137109 13.540936 53.86027 55.108769 95.428991a399.812548 399.812548 0 0 0 3.868839 3.816485c-18.446198-2.465941-38.703473-3.828908-59.958128-3.828908-77.080402 0-141.021837 17.917338-153.042745 41.397463-17.152444 22.420631-29.056222 71.617886-29.056222 128.705442 0 78.219757 22.352305 141.629671 49.931092 141.629671 27.578787 0 49.939965-63.409913 49.939965-141.629671 0-29.986163-3.285851-57.794773-8.891231-80.689248 25.579591 5.930149 57.067147 9.428076 91.118253 9.428076 22.752499 0 44.362094-1.561733 63.828742-4.367528a399.907494 399.907494 0 0 0-7.739452 7.534475c-41.568721 41.568721-66.240555 84.298094-55.109657 95.428991 11.137109 11.137109 53.86027-13.540049 95.428991-55.10877 34.770745-34.770745 57.718461-70.344541 57.776139-87.567972a16.620035 16.620035 0 0 0 0.897109-5.344499c0-2.19175-0.448111-4.351556-1.316825-6.468769-3.259231-18.402718-25.271681-51.17338-57.355535-83.25546z m40.5181 350.441373c0 29.983501 3.284076 57.788562 8.887681 80.682149-25.582253-5.927487-57.071584-9.425414-91.124464-9.425414-22.751612 0-44.360319 1.561733-63.825193 4.365754a405.916617 405.916617 0 0 0 7.747439-7.542461c41.568721-41.568721 66.240555-84.285671 55.102558-95.42278-11.130898-11.130898-53.853172 13.533837-95.42278 55.102558-34.768971 34.768971-57.715799 70.348977-57.779688 87.573296a16.628908 16.628908 0 0 0-0.894447 5.340063c0 2.184652 0.444562 4.337359 1.307064 6.447473 3.242371 18.400055 25.269019 51.187577 57.367958 83.287403 41.568721 41.567834 84.285671 66.240555 95.42278 55.102559 11.130898-11.130898-13.533837-53.853172-55.102558-95.42278a410.577858 410.577858 0 0 0-3.868839-3.81826c18.440873 2.466828 38.693712 3.828908 59.945706 3.828908 77.092825 0 141.048458-17.930648 153.056943-41.416985 17.148007-22.42773 29.051785-71.612562 29.051785-128.681483 0-78.228631-22.361179-141.638544-49.939966-141.638544-27.578787 0-49.931092 63.409913-49.931091 141.638544z" fill="#FFFFFF" p-id="8066"></path></svg>
                    </div>
                </div>
                <el-scrollbar class="home-rqzj-l-tree-container">
                    <el-tree
                      class="home-custom-tree"
                      :data="categoryList"
                      :show-expand="true"
                      style="max-width: 240px;"
                      @node-click="handleNodeClick">
                        <template #default="{ data }">
                            <div class="home-custom-tree-node" :title="charConversion(data.categoryName)">
                                <div class="home-tree-l">
                                    <i>
                                        <svg t="1755142425021" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20345" width="16" height="16"><path d="M861.9 843.5c0 31.1-25.2 56.2-56.2 56.2H103.5l98.3-454.2c0-31 25-56.2 56.1-56.2h646.2c31 0 56.1 25.2 56.1 56.2l-98.3 398zM215.8 347.1h632v-55.2c0-31-25.2-56.2-56.2-56.2h-337v-50.9c0-31-25.2-56.2-56.2-56.2H117.6c-31 0-56.2 25.2-56.2 56.2v658.6l98.2-440.2c0-30.9 25.2-56.1 56.2-56.1z m0 0" p-id="20346" fill="#e99d42"></path></svg>
                                    </i>
                                    <span>{{charConversion(data.categoryName)}}</span>
                                </div>
                            </div>
                        </template>
                    </el-tree>
                </el-scrollbar>
            </div>
            <!--文件列表-->
            <div class="home-r-container">
                <div class="home-form-box">
                    <el-form ref="queryForm"
                             :model="queryParams"
                             :inline="true"
                             label-width="90px">
                        <el-row >
                            <el-col :span="8"></el-col>
                            <el-col :span="8"></el-col>
                            <el-col :span="8">
                                <el-form-item class="pull-right">
                                    <el-input v-model="queryParams.fileName" placeholder="请输入文件名称" class="input-with-select">
                                        <template #append>
                                            <el-button type="primary" @click="queryFileList(null)" style="background-color: #ff7f2e;color: #fff" icon="el-icon-search" />
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <div class="bre9e mt5">
                    <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                              height="calc(100vh - 215px)"
                              v-loading="loading"
                              :data="dataList"
                              highlight-current-row>
                        <el-table-column type="index" align="center" label="序号" width="60" />
                        <el-table-column  align="center" label="文件名称" prop="fileName">
                            <template #default="scope">
                                <div :title="scope.row.fileName" style="color: #409efe;" class="text-one cursor">
                                    {{ scope.row.fileName }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column width="120px" align="center" label="文件大小" prop="duration">
                            <template #default="scope">
                                <div>{{ scope.row.fileSize}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column width="140px" align="center" label="上传时间" prop="creationTime">
                            <template #default="scope">
                                {{ timestampToTime(scope.row.createTime) }}
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" width="100" label="操作" align="center">
                            <template #default="scope">
                                <el-button type="primary" style="background-color: #ff7f2e;color: #fff" size="small" @click="handleView(scope.row)">查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="zdyfy">
                    <pagination class="zdyfy" :background="false"
                                :pageSizes="[10, 20, 30]"
                                :total="total"
                                v-model:page="queryParams.pageNum"
                                v-model:limit="queryParams.pageSize"
                                @pagination="queryFileList" />
                </div>
            </div>
        </div>
        <div class="home-event-page-container" v-show="showMode==='file'">
            <div class="head-container">
                <div class="left-head-container" @click="backTreePage">
                    <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                </div>
                <div class="right-head-container">{{fileName}}</div>
                <div class="left-head-container">
                </div>
            </div>
            <el-scrollbar class="museum-event-info-container">
                <iframe :src="this.openFileUrl" frameborder="0" style="width:100%; height:calc(100vh - 150px)"></iframe>
            </el-scrollbar>
        </div>
    </div>

</template>
<script>
import {serviceUrl} from "@/utils/global";
import {charConversion} from "@/utils/str"
import {treeFileCategory, pageCategoryFile} from "@/api/admin/fileCategory"
import {timestampToTime} from "@/utils/date";

export default {
    name: "rqzjTreeDetail",
    components: {},
    props:{
        subjectKey:{
            type: String,
            default:null
        },
        markInfo:{
            type: String,
            default:null
        },
    },
    watch:{
        subjectKey(newValue,oldValue){
            this.categorySubject = newValue
            this.categoryForm.categorySubject = newValue
            this.queryParams.categorySubject = newValue
            this.queryCategoryForm.categorySubject = newValue
            this.showMode = 'tree'
            this.queryTreeCategory();
            this.queryFileList(null);
        },
        markInfo(newValue,oldValue){
            this.showMode = 'tree'
        },

    },
    data() {
        return {
            token: this.$storage.get("token"),
            charConversion,
            serviceUrl,
            showMode:"tree",
            loading: false,
            isShowCategoryDialog:false,
            isShowCategoryUpdateDialog:false,
            isShowFileDialog:false,
            categorySubject:'',
            treeList:{},
            treeData:{},
            categoryList:[],
            defaultProps: {
                children: 'children',
                label: 'categoryName',
            },
            dialogTitle:'',
            categoryForm:{
                categoryId: '',
                parentId: '',
                categoryName: '',
                categoryProfile: '1',
                categorySubject: '',
            },
            queryCategoryForm:{
                categoryProfile: '1',
                categorySubject: '',
            },
            //文件上传】
            fileList:[],
            delFileList:[],
            categoryId:'',
            fileName:'',
            //查询文件分页
            queryParams:{
                pageNum: 1,
                pageSize: 10,
                categoryProfile: '1',
                categorySubject: '',
                fileName: '',
                categoryId: '',
            },
            total: 0,
            dataList: [],
            openFileUrl:'',
        }
    },
    computed: {},
    created() {},
    mounted(){
        // this.queryTreeCategory();
        // this.queryFileList(null);
    },
    methods: {
        resetSearch(){
            this.queryParams.fileName = '';
            this.queryParams.categoryId = '';
            this.queryFileList(null);
        },
        backList() {
            this.showMode = "page"
            this.$emit('change-mode', this.showMode);
        },
        timestampToTime,
        handleNodeClick(e, i){
            this.queryParams.categoryId=e.categoryId;
            this.queryFileList();
        },
        queryFileList(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageCategoryFile(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.loading = false;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        handleView(file){
            this.fileName = file.fileName;
            this.openFileUrl = 'https://ow365.cn/?i=36735&ssl=1&furl=' +file.fileUrl;
            this.showMode = "file";
        },
        // 提交修改
        handleUpdate(data){
            this.dialogTitle = '修改目录名称'
            this.categoryForm.categoryId = data.categoryId;
            this.categoryForm.categoryName = data.categoryName;
            this.isShowCategoryUpdateDialog = true;
        },
        // 查询树结构
        queryTreeCategory(){
            treeFileCategory(this.queryCategoryForm).then(res => {
                if (res.data.code === 1) {
                    this.categoryList = res.data.data;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },

        backTreePage(){
            this.showMode = "tree";
        },
    }
}
</script>
<style>
.home-rqzj-container{
    width: 100%;
    background-color: #fff;
    height: calc(100vh - 90px);
}
.home-rqzj-manager-container{
    width: 100%;
    height: calc(100vh - 85px);
    overflow: hidden!important;
    box-sizing: border-box;
    display: flex;
}
.home-event-page-container{
    width: 100%;
    height: calc(100vh - 85px);
    background-color: #fff;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.home-l-container{
    width: 260px;
    height: 100%;
    background-color: #fff;
    border-radius: 4px;
}
.home-l-top-container{
    width: 100%;
    height: 50px;
    padding: 10px 0 10px 0;
    line-height: 28px;
    box-sizing: border-box;
    border-bottom: 1.5px solid #f1f1f1;
    display: flex;
}
.home-form-box{
    width: 100%;
    height: 44px;
    padding: 10px 0 0 0;
    box-sizing: border-box;
}
.home-l-box{
    width: 30px;
    height: 100%;
}
.home-r-box{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 18px;
    font-family: sans-serif;
    text-align: center;
    padding-right: 10px;
    color: #333;
    font-weight: bold;

}
.home-rqzj-l-tree-container{
    width: 100%;
    height: calc(100% - 60px)!important;
    padding: 0 0 0 10px;
    box-sizing: border-box;

}
.home-custom-tree-node{
    width: calc(100% - 24px);
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
}
.home-tree-l{
    width: calc(100% - 20px);
    white-space: nowrap; /* 防止文本换行 */
    overflow: hidden; /* 隐藏溢出的内容 */
    text-overflow: ellipsis; /* 显示省略号来表示溢出内容 */
}
.home-r-container{
    width: calc(100% - 260px);
    height: 100%;
    background-color: #fff;
    border-radius: 4px;
    padding: 0 10px 0 0;
    box-sizing: border-box;
}

.head-container{
    width: 100%;
    height: 44px;
    display: flex;
}
.left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    line-height: 44px;
    font-weight: bold;
}
.museum-event-info-container{
    width: 100%;
    height: calc(100% - 30px)!important;
    padding: 0 10px 10px 10px;
    box-sizing: border-box;
}
</style>